/**
 * A water meter's litre hand is geared to one turn per litre, so the flow dial
 * needs the reading in litres a minute whatever unit the device reports — a
 * `m³/h` reading turned at the same pace as `L/min` would run 16.7× slow.
 *
 * An unknown unit is taken at that same scale (the dial's own), and anything
 * that is not a positive, finite number is no flow at all.
 */
const LITRES_PER_MINUTE: Record<string, number> = {
  'l/s': 60,
  'l/min': 1,
  'l/h': 1 / 60,
  'm³/h': 1000 / 60,
  'm3/h': 1000 / 60,
  'm³/min': 1000,
  'm3/min': 1000,
  'gal/min': 3.785411784,
  gpm: 3.785411784,
};

/** The reading as litres a minute, the pace the litre hand turns at. */
export function flowLitresPerMinute(
  value: number | null | undefined,
  unit: string | null | undefined,
): number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return 0;
  const key = (unit ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');
  return value * (LITRES_PER_MINUTE[key] ?? 1);
}
